import React, { useMemo } from "react";
import { useState } from "react";
import { useReducer } from "react";

export const useMarketOrderEnabled = (tactic) => {
  const [marketOrderEnabled, setMarketOrderEnabled] = useState(
    tactic !== undefined
  );
  return [marketOrderEnabled, setMarketOrderEnabled];
};
export const useLimitOrderEnabled = (tactic) => {
  const [limitOrderEnabled, setLimitOrderEnabled] = useState(
    tactic !== undefined
  );
  return [limitOrderEnabled, setLimitOrderEnabled];
};

export const useCandleBreakEnabled = (tactic) => {
  const [candleBreakEnabled, setCandleBreakEnabled] = useState(
    tactic !== undefined
  );
  return [candleBreakEnabled, setCandleBreakEnabled];
};

export const useMarketOrder = (startingValue) => {
  const [marketOrder, dispatchMarketOrder] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      quantityBasisValue: startingValue !== undefined ? startingValue : 0,
    }
  );
  return [marketOrder, dispatchMarketOrder];
};

export const useLimitOrder = (startingValue) => {
  const [limitOrder, dispatchLimitOrder] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      offsetFromSetupPrice: 0,
      limitPrice: 0,
      quantityBasisValue: startingValue !== undefined ? startingValue : 0,
      setLimitFromSetupBreakPrice: false,
    }
  );
  return [limitOrder, dispatchLimitOrder];
};
export const useCandleBreak = () => {
  const [candleBreak, dispatchCandleBreak] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      candleDuration: 1,
      quantityBasisValue: 0,
      waitUntilCurrentCandleCloses: false,
      breakBy: 0.0,
    }
  );
  return [candleBreak, dispatchCandleBreak];
};

export const useEntryTactics = (
  market_order_enabled,
  market_order,
  limit_order_enabled,
  limit_order,
  candle_break_enabled,
  candle_break
) => {
  const [marketOrderEnabled, setMarketOrderEnabled] = market_order_enabled;
  const [marketOrder, dispatchMarketOrder] = market_order;
  const [limitOrderEnabled, setLimitOrderEnabled] = limit_order_enabled;
  const [limitOrder, dispatchLimitOrder] = limit_order;
  const [candleBreakEnabled, setCandleBreakEnabled] = candle_break_enabled;
  const [candleBreak, dispatchCandleBreak] = candle_break;
  const entryTactics = useMemo(
    () => ({
      ...(marketOrderEnabled && { MARKET_ORDER: marketOrder }),
      ...(limitOrderEnabled && { LIMIT_ORDER: limitOrder }),
      ...(candleBreakEnabled && { CANDLE_BREAK: candleBreak }),
    }),
    [
      marketOrderEnabled,
      limitOrderEnabled,
      candleBreakEnabled,
      marketOrder,
      limitOrder,
      candleBreak,
    ]
  );
  return entryTactics;
};
